import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';

import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import TimeTable from '../time-table/TimeTable';
import { toTimeRows } from '../time-table/timeTableSlice';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { SerializedError } from '../../util/types';
import Metadata from '../metadata/Metadata';
import MDViewer from '../markdown/Markdown';
import {
  Ticket,
  selectTicket,
  selectChildrenItems,
} from './ticketSlice';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';
import TicketDisplay from './TicketDisplay';
import TicketPaneViewer from './TicketPaneViewer';
import { ToolBar } from './RightToolBar';
import { ToolBar as LeftToolBar} from './LeftToolBar';

const vcontentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	display: 'flex',
	//backgroundColor: 'pink',
};
const contentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	//overflow: 'auto',
	display: 'flex',
	//backgroundColor: 'grey',
};
const colOneStyle = {
	height: '100%',
	flexGrow: 4,
	width: '50%',
	//backgroundColor: '#eeeeee',
	//overflow: 'auto',
};
const colTwoStyle = {
	height: '100%',
	flexGrow: 4,
	//backgroundColor: 'green',
	width: '50%',
	//overflow: 'auto',
};
const viewStyle = {
	height: `calc(100% - 44px)`,
	overflow: 'auto',
	padding: 2,
	width: '100%',
	//height: '100%r',
	//backgroundColor: 'purple',
};

export function TicketViewer() {

	let { id } = useParams();
	const idv = id ? id : null;
	const idStr = id ? id : "";
	//c onsole.log("2024101608254", idStr);
	const {
		//data: TicketItemsResponse,
		data,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useTicketViewQuery(idStr, { refetchOnMountOrArgChange: true});
   	return (
		<Box sx={vcontentStyle}>
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={viewStyle}>
                        <Grid container sx={vcontentStyle}>
							<Grid size={{ xs: 12, md: 6}}>
					<LeftToolBar
						id={idv}
						data={data}
						isLoading={isLoading}
						isFetching={isFetching}
						isSuccess={isSuccess}
						isError={isError}
						error={error}
					/>
					<Box sx={{height: 45}}>
					</Box>
						<TicketViewerLeft
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
						/>
                            </Grid>
							<Grid size={{ xs: 12, md: 6}}>
					<ToolBar />
					<Box sx={{height: 45}}>
						ktype
					</Box>
						<TicketViewerRight
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
						/>
                            </Grid>
                        </Grid>
					</Box>
				</Box>
			</Box>
		</Box>
    );
 /*
     * 2025-09-02T07h16
	return (
		<Box sx={vcontentStyle}>
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<LeftToolBar
						id={idv}
						data={data}
						isLoading={isLoading}
						isFetching={isFetching}
						isSuccess={isSuccess}
						isError={isError}
						error={error}
					/>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<TicketViewerLeft
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
						/>
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<ToolBar />
					<Box sx={{height: 45}}>
						ktype
					</Box>
					<Box sx={viewStyle}>
						<TicketViewerRight
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
						/>
						<Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
    // */
}
interface QueryProps {
	id: string | null;
	data: TicketItemsResponse;
	isLoading: boolean;
	isFetching: boolean;
	isSuccess: boolean;
	isError: boolean;
	error: FetchBaseQueryError | SerializedError | undefined;
};

export function TicketViewerLeft({
	id,
	data,
	isLoading,
	isFetching,
	isSuccess,
	isError,
	error
}: QueryProps) {
	const ticket = useAppSelector(selectTicket(id ? id : ""));
	let content: React.ReactNode

	if (isLoading) {
		content = <TicketViewerLoading />
	} else if (isFetching) {
		content = <TicketViewerFetching />
	} else if (isSuccess) {
		content = <TicketViewerSuccess ticket={ticket}/>
	} else if (isError) {
		content = <TicketViewerError error={error} />
	}
	return (
		<Box>
			{
				content
			/*
			error
				? (<TicketViewerLoading />)
				: isLoading
					? ( <TicketViewerFetching /> )
					: data
						? ticket
							? ( <TicketViewerSuccess ticket={ticket} /> )
							: ( <TicketViewerError error={error} /> )
						: null
			// */
			}
		</Box>
	)
}

export function TicketViewerRight({
	id,
	data,
	isLoading,
	isFetching,
	isSuccess,
	isError,
	error
}: QueryProps) {
	const tItems = useAppSelector(selectChildrenItems(id));
	const tRows = toTimeRows(tItems);
	return (
		<Box>
			<TimeTable
				data={tRows}
				refDate={new Date()}
				linkTo={"context"}
				titleLink={(id: string) => '/ticket/view/' + id}
			/>
		</Box>
	)
}

export function TicketViewerLoading() {
	return (
		<Box>
			Loading
			<LinearProgress />
		</Box>
	);
}

export function TicketViewerFetching() {
	return (
		<Box>
			Fetching
		</Box>
	);
}

export function TicketViewerError(
	{error}: {error: FetchBaseQueryError | SerializedError | undefined }
) {
	return (
		<Box>
			Error
		</Box>
	);
}

export function TicketViewerSuccess({ticket}: {ticket: Ticket | null}) {
	if (ticket) {
		return (<TicketDisplay ticket={ticket} />);
	} else {
		return (<Box> Nothing </Box>)
	}
}

/*
export function TicketViewerPane({ticket}: {ticket: Ticket}) {
	return (
		<Box>
			<Typography variant="title">{ticket.title}</Typography>
			<Metadata meta={ticket.metadata}/>
			<MDViewer md={ticket.content.content} />
		</Box>
	);
}
// */
